export default {
  tg24: {
    title: 'Video',
    header: {
      title: 'Diretta TG24',
      description: 'Scopri le ultime news nella diretta video in streaming di Sky TG24',
      hrefProd: 'https://tg24.sky.it/',
      hrefColl: 'https://test.tg24.sky.it/',
    },
  },
  sport: {
    title: 'Skylights Room',
    header: {
      title: 'Tutti gli highlights dei tuoi sport preferiti!',
      description:
        'Calcio, basket, motori seleziona la raccolta che preferisci e inizia subito a visualizzare gli highlights.',
      hrefProd: 'https://sport.sky.it/',
      hrefColl: 'https://test.sport.sky.it/',
    },
  },
};
